<template>
  <SettingsPageAutoPostKartePlannerCommentView v-if="viewer" :viewer="viewer" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useSettingsPageAutoPostKartePlannerCommentViewFetcherQuery } from './SettingsPageAutoPostKartePlannerCommentViewFetcher.generated'
import SettingsPageAutoPostKartePlannerCommentView from './SettingsPageAutoPostKartePlannerCommentView.vue'

const { result } = useSettingsPageAutoPostKartePlannerCommentViewFetcherQuery()
const viewer = computed(() => result.value?.viewer)
</script>
